import { Rpc } from '@/models/Rpc';
import { rpcClient } from '@/support/Clients/RpcClient';

export default class StatelessUpload {
  public static async handle(file: File): Promise<StatelessUploadResponse> {
    const { key, disk } = await StatelessUpload.getUploadForm(file);
    return { key: `stateless-upload://${disk}/${key}`, file };
  }

  protected static async getUploadForm(file: File): Promise<UploadForm> {
    // const payload = { config: { filetype: file.type } };

    const payload = {
      signature: 'stateless-uploads:form:create',
      body: {
        config: { filetype: file.type },
      },
    };

    const formdataResponse = await new Rpc()
      .post(payload);

    // const formdataResponse: FormdataResponse = await rpcClient('stateless-uploads:form:create', payload);

    if (! formdataResponse.formdata) {
      throw new Error('Formdata response missing.');
    }

    const response = await StatelessUpload.uploadImageToS3(formdataResponse.formdata, file);

    return StatelessUpload.extractS3Key(response, formdataResponse.disk);
  }

  protected static buildUploadPayload(formdata: Formdata, file: File): FormData {
    const payload = new FormData();
    Object.keys(formdata.inputs).forEach((key: string) => {
      const value = formdata.inputs[key];

      if (value) {
        payload.append(key, value);
      }
    });

    payload.append('Content-Type', file.type);
    payload.append('file', file);

    return payload;
  }

  protected static async uploadImageToS3(formdata: Formdata, file: File): Promise<Response> {
    return fetch(formdata.attributes.action, {
      method: formdata.attributes.method,
      body: StatelessUpload.buildUploadPayload(formdata, file),
    });
  }

  protected static async extractS3Key(response: Response, disk: string): Promise<UploadForm> {
    const responseText = await response.text();

    const match = responseText.match(/<Key>(.+?)<\/Key>/);

    if (match && match[1]) {
      return { key: match[1], disk };
    }

    throw new Error(`Failed to extract s3 key from: ${responseText}`);
  }
}

export interface StatelessUploadResponse {
  file: File;
  key: string;
}

interface Formdata {
  attributes: {
    action: string;
    method: string;
    enctype: string;
  };
  inputs: {
    [key: string]: string;
    acl: string;
    key: string;
    'Content-Type': string;
    Policy: string;
  };
}

interface FormdataResponse {
  id: string;
  disk: string;
  formdata: Formdata;
  debug_rendered_html?: string;
}

interface UploadForm {
  disk: string;
  key: string;
}
